import { z } from "zod";

const BOARD_SHAPE_ID_PATTERN = /^shape:[A-Za-z0-9_-]+$/;

export const cardIdSchema = z
	.string()
	.min(1)
	.describe("Illumi card entity id from listVisibleCards or listPromptCards");

export const shapeIdSchema = z
	.string()
	.regex(
		BOARD_SHAPE_ID_PATTERN,
		"Must be an exact shapeId from listShapesInViewport (e.g. shape:abc123)",
	)
	.describe(
		"Exact shapeId from listShapesInViewport or listSelectedShapes — never invent ids",
	);
